type NetlifyImageLoaderParams = {
  src: string;
  width: number;
  quality?: number;
};

/**
 * Custom next/image loader.
 *
 * Production (Netlify): route through the native Netlify Image CDN
 * (`/.netlify/images`) instead of Next.js's own `/_next/image` optimizer, whose
 * bundled function in @netlify/plugin-nextjs v5 currently 502s under Next 16.
 * Remote sources (e.g. images.ctfassets.net) are allowlisted via the
 * `[images] remote_images` setting in netlify.toml — that allowlist is what now
 * enforces our SSRF hardening, in place of next.config's remotePatterns.
 *
 * Local dev (`next dev`): the Netlify Image CDN does not exist off-platform, so
 * we serve the source directly (the `?w=` is honored by Contentful and harmless
 * for local /static assets). The branch is gated on NODE_ENV, which Next inlines
 * identically on the server and client, so there is no hydration mismatch.
 */
export default function netlifyImageLoader({
  src,
  width,
  quality,
}: NetlifyImageLoaderParams): string {
  if (process.env.NODE_ENV === 'development') {
    const separator = src.includes('?') ? '&' : '?';
    return `${src}${separator}w=${width}`;
  }

  const params = new URLSearchParams();
  params.set('url', src);
  params.set('w', String(width));
  params.set('q', String(quality ?? 75));
  return `/.netlify/images?${params.toString()}`;
}
